import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('mobile-info-dialog', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('mobile-info-dialog');

      return new ViewModel(params, element);
    },
  },
  template: html,
});
